import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Orders.css';
import Header from "../../Components/Header/Header";
import ShopBanner from "../../Components/Banner/Banner";
import Footer from '../../Components/Footer/Footer';
import { getOrderList, getCartist, getWishist, updatepassword, getcartwishlistcount } from "../../redux/services/productService";
import BottomNavigation from '../../Components/BottomMenu/BottomNavigation';
import OrderComplete from '../Checkout/Ordercomplete';
import Swal from "sweetalert2";
import { encrypt } from '../../redux/services/encryptionUtils';
import withReactContent from 'sweetalert2-react-content';
import banner1 from "../../assets/images/banner1.png"
import HeaderDummy from '../../Components/Header/HeaderDummy';
import SearchHeader from '../../Components/Header/SearchHeader';

const Orders = () => {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem('accessToken');

  const [orders, setOrders] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [cartCount, setCartCount] = useState(0);
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [wishlist, setWishlist] = useState([]);
  const [isLowEndDevices, setIsLowEndDevices] = useState(window.innerWidth <= 950);
  const [cartwishlistCount, setCartwishlistCount] = useState({CartCount:0,WishlistCount:0,CartAmount:0});
    
      useEffect(() => {
      const handleResize = () => setIsLowEndDevices(window.innerWidth <= 950);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchOrders = async (page) => {
    try {
      setLoading(true);
      const response = await getOrderList(page);
      
      if (response?.status == "Success") {
        const parsedResult = JSON.parse(response.result);
        const data = parsedResult?.Data || [];
        const PageSummary = parsedResult?.PageSummary || [];
        
        
        setOrders(data);

        // ✅ If less than 10 records, stop further pages
        setHasMore(page<PageSummary[0]?.TotalPages);
      }
      // ✅ Show only 10 orders at a time (replace instead of append)
      
    } catch (error) {
      console.error("Error loading orders:", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchOrders(pageNumber);
  }, [pageNumber]);

  const handleNext = () => {
    if (hasMore && !loading) {
      setPageNumber(prev => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (pageNumber > 1 && !loading) {
      setPageNumber(prev => prev - 1);
    }
  };

  // useEffect(() => {
  //   const fetchCart = async () => {
  //     try {
  //       const res = await getCartist();
  //       const parsedResult = JSON.parse(res.result);
  //       if (parsedResult?.Data) {
  //         const mappedItems = parsedResult.Data.map((item, index) => ({
  //           id: item.TransId || index,
  //           transId: item.TransId,
  //           productId: item.Product, // important for matching
  //           name: item.Product_Name || "Unnamed Product",
  //           price: item.Rate || 0,
  //           quantity: item.Quantity || 1,
  //           image: "/api/placeholder/60/60",
  //         }));
  //         const totalQuantity = mappedItems.reduce((sum, item) => sum + (item.quantity || 1), 0);
  //         setCartItems(mappedItems);
  //         setCartCount(mappedItems.length);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching cart:", error);
  //     }
  //   };

  //   fetchCart();
  // }, []);

  // // fetch wishlist
  // useEffect(() => {
  //   const fetchWishlist = async () => {
  //     try {
  //       const res = await getWishist();
  //       const parsedResult = JSON.parse(res.result);
  //       setWishlist(parsedResult.Data || []);
  //     } catch (error) {
  //       console.error("Error fetching wishlist:", error);
  //     }
  //   };

  //   fetchWishlist();
  // }, []);

  useEffect(() => {
        const fetchCartWishlistCount = async () => {
          try {
            const res = await getcartwishlistcount({BE:1});
            if(res?.status =="Success"){
              const parsedResult = JSON.parse(res.result);
              
              setCartwishlistCount(parsedResult[0]);
            }
            else{
              setCartwishlistCount({});
            }
            
          } catch (error) {
            console.error("Error fetching wishlist:", error);
            setCartwishlistCount({});
          }
        };
    
        fetchCartWishlistCount();
      }, []);

  const handleClick = () => {
    navigate('/trackorder');
  };

  // 🕒 Helper to format date/time nicely
  const formatDateTime = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;

    const formattedDate = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    return `${formattedDate}`;
  };

  const handleLogout = () => {
    // Clear all authentication data
    localStorage.removeItem("authToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("accessToken")
    localStorage.removeItem('refreshToken');

    navigate(`/login`);
  };

  const handleViewOrder = (orderId) => {
    setSelectedOrderId(orderId);
  };

  const MySwal = withReactContent(Swal);
  setTimeout(() => {
  if (window.innerWidth < 400) {
    document.querySelectorAll(".eye-icon").forEach(el => {
      el.style.display = "none";
    });
  }
}, 50);


  const showResetPasswordAlert = async () => {
    const { value: formValues } = await MySwal.fire({
      title: "Reset Password",
      html: `
      <div class="password-input-container">
  <input type="password" id="oldPassword" class="password-swal-input" placeholder="Old Password" autoComplete="new-password" maxlength="30">
  <span class="password-eye-icon password-open-eye" data-target="oldPassword">
    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5C21.27 7.61 17 4.5 12 4.5zm0 12a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"/></svg>
  </span>
  <span class="password-eye-icon password-close-eye" data-target="oldPassword" style="display:none;">
    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555"><path d="M12 6a9.77 9.77 0 0 1 9 6 9.77 9.77 0 0 1-9 6 9.77 9.77 0 0 1-9-6 9.77 9.77 0 0 1 9-6m0-2C6.5 4 1.73 7.11 0 12c1.73 4.89 6.5 8 12 8s10.27-3.11 12-8c-1.73-4.89-6.5-8-12-8Zm5.59 11.41L14.17 12l3.42-3.41L16 7l-4 4-4-4-1.41 1.59L9.83 12l-3.42 3.41L8 17l4-4 4 4 1.59-1.59Z"/></svg>
  </span>
</div>

<div class="password-input-container">
  <input type="password" id="newPassword" class="password-swal-input" placeholder="New Password" maxlength="30">
  <span class="password-eye-icon password-open-eye" data-target="newPassword">
    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5C21.27 7.61 17 4.5 12 4.5zm0 12a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"/></svg>
  </span>
  <span class="password-eye-icon password-close-eye" data-target="newPassword" style="display:none;">
    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555"><path d="M12 6a9.77 9.77 0 0 1 9 6 9.77 9.77 0 0 1-9 6 9.77 9.77 0 0 1-9-6 9.77 9.77 0 0 1 9-6m0-2C6.5 4 1.73 7.11 0 12c1.73 4.89 6.5 8 12 8s10.27-3.11 12-8c-1.73-4.89-6.5-8-12-8Zm5.59 11.41L14.17 12l3.42-3.41L16 7l-4 4-4-4-1.41 1.59L9.83 12l-3.42 3.41L8 17l4-4 4 4 1.59-1.59Z"/></svg>
  </span>
</div>

<div class="password-input-container">
  <input type="password" id="confirmPassword" class="password-swal-input" placeholder="Confirm Password" maxlength="30">
  <span class="password-eye-icon password-open-eye" data-target="confirmPassword">
    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5C21.27 7.61 17 4.5 12 4.5zm0 12a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"/></svg>
  </span>
  <span class="password-eye-icon password-close-eye" data-target="confirmPassword" style="display:none;">
    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555"><path d="M12 6a9.77 9.77 0 0 1 9 6 9.77 9.77 0 0 1-9 6 9.77 9.77 0 0 1-9-6 9.77 9.77 0 0 1 9-6m0-2C6.5 4 1.73 7.11 0 12c1.73 4.89 6.5 8 12 8s10.27-3.11 12-8c-1.73-4.89-6.5-8-12-8Zm5.59 11.41L14.17 12l3.42-3.41L16 7l-4 4-4-4-1.41 1.59L9.83 12l-3.42 3.41L8 17l4-4 4 4 1.59-1.59Z"/></svg>
  </span>
</div>
    `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Close",
      reverseButtons: true,
      customClass: {
        confirmButton: "next-btn2",
      },
      preConfirm: () => {
        const oldPassword = document.getElementById("oldPassword").value;
        const newPassword = document.getElementById("newPassword").value;
        const confirmPassword = document.getElementById("confirmPassword").value;

        if (!oldPassword) {
          Swal.showValidationMessage("Old Password is required");
          return false;
        }
        if (!newPassword) {
          Swal.showValidationMessage("New password is required");
          return false;
        } 
        if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/.test(newPassword)) {
          Swal.showValidationMessage("Password must be at least 6 characters long and include at least one letter, one number, and one special character.");
          return false
        }
        if (!confirmPassword) {
          Swal.showValidationMessage("Confirm password is required");
          return false;
        }
        if (newPassword !== confirmPassword) {
          Swal.showValidationMessage("Passwords do not match");
          return false;
        }

        return { oldPassword, newPassword };
      },
      didOpen: () => {
        const inputs = document.querySelectorAll(".custom-swal-input");
        inputs.forEach((input) => {
          input.style.fontSize = "14px";
          input.style.paddingRight = "40px";
        });

        // Eye toggle functionality
        // Add click event listeners to all eye icons
document.querySelectorAll('.password-eye-icon').forEach(icon => {
  icon.addEventListener('click', function() {
    const targetId = this.getAttribute('data-target');
    const passwordInput = document.getElementById(targetId);
    const openEye = this.classList.contains('password-open-eye');
    const closeEye = this.classList.contains('password-close-eye');
    
    if (openEye) {
      // Switch to text (visible)
      passwordInput.type = 'text';
      this.style.display = 'none';
      document.querySelector(`.password-close-eye[data-target="${targetId}"]`).style.display = 'block';
    } else if (closeEye) {
      // Switch to password (hidden)
      passwordInput.type = 'password';
      this.style.display = 'none';
      document.querySelector(`.password-open-eye[data-target="${targetId}"]`).style.display = 'block';
    }
  });
});
      },
    });

    if (formValues) {
      try {
        const encryptedOldPassword = await encrypt(formValues.oldPassword);
        const encryptedPassword = await encrypt(formValues.newPassword);

        const postData = {
          oldPassword: encryptedOldPassword,
          newPassword: encryptedPassword,
        };

        const response = await updatepassword(postData);

        if (response.status === "Success") {
          await MySwal.fire("Success", "Password has been updated successfully!", "success");
        } else {
          await MySwal.fire("Error", response.message || "Failed to update password", "error");
        }
      } catch (error) {
        console.error("Reset Password Error:", error);
      }
    }
  };



  return (
    <>
             {isLowEndDevices ? (
  <>

      <Header />
       <SearchHeader
        cartwishlistCount={cartwishlistCount}
        categories={[]}
        selectedCategory={null}
        cartTrigger={0}
        wishlistTrigger={0}
        otherScreens={true}
         />
     </>) : (
  <>
        <HeaderDummy/>
    <SearchHeader
        cartwishlistCount={cartwishlistCount}
        categories={[]}
        selectedCategory={null}
        cartTrigger={0}
        wishlistTrigger={0}
        otherScreens={true}
         />
    <Header />
  </>
)}
      <ShopBanner
        header=""
        badgeText="Account"
        subheader=""
        backgroundImage={banner1}
        height="60px"
      />

      <div className="account-container">
        <div className="orders-sidebar">
          <h1 className="orders-account-title">MY ACCOUNT</h1>
          <nav className="orders-nav-menu2">
            {/* <a href="#" className="orders-nav-item">Dashboard</a> */}
            <a href="#" className="orders-nav-item orders-active">Orders</a>
            {/* <a href="#" className="orders-nav-item">Downloads</a>
            <a href="#" className="orders-nav-item">Addresses</a>
            <a href="#" className="orders-nav-item">Account details</a>
            <a href="#" className="orders-nav-item">Buy again</a> */}
            <a href="#" className="orders-nav-item" onClick={() => navigate('/wishlist')}>Wishlist</a>
            <a href="#" className="orders-nav-item orders-logout-item" onClick={showResetPasswordAlert}>
              Reset Password
            </a>
            <a href="#" className="orders-nav-item orders-logout-item" onClick={handleLogout}>
              Logout
            </a>
          </nav>
        </div>

        <div className="orders-content">
          {selectedOrderId ? (
            <div>
              <button
                className="orders-back-btn"
                onClick={() => setSelectedOrderId(null)}
                style={{
                  marginBottom: '20px',
                  padding: '8px 18px',
                  fontSize: '14px',
                  borderRadius: '25px',
                  background: '#e94e1b',
                  color: '#fff',
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 600
                }}
              >
                ← Back to Orders
              </button>
              <OrderComplete orderId={selectedOrderId} viewOrder={true} />
            </div>
          ) : (
            <>
              <div className="orders-orders-header">
                <div className="orders-header-col orders-order-col">ORDER</div>
                <div className="orders-header-col orders-date-col">DATE & TIME</div>
                <div className="orders-header-col orders-status-col">STATUS</div>
                <div className="orders-header-col orders-total-col">TOTAL</div>
                <div className="orders-header-col orders-actions-col"></div>
              </div>

              {orders.length > 0 ? (
                orders.map((order, index) => (
                  <div key={index} className="orders-order-row">
                    <div className="orders-order-cell orders-order-col" data-label="ORDER">
                      <span className="orders-order-id">#{order.Docno}</span>
                    </div>
                    <div className="orders-order-cell orders-date-col" data-label="DATE & TIME">
                      <span className="orders-order-date">{formatDateTime(order.Date)}</span>
                    </div>
                    <div className="orders-order-cell orders-status-col" data-label="STATUS">
                      <span className="orders-order-status">{order.Status}</span>
                    </div>
                    <div className="orders-order-cell orders-total-col" data-label="TOTAL">
                      <span className="orders-order-total">{new Intl.NumberFormat("en-US").format(order.Total)} AED</span>
                      <span className="order-items" style={{ marginLeft: "2px" }}>for {new Intl.NumberFormat("en-US").format(order.Qty)} items </span>
                    </div>
                    <div className="orders-order-cell orders-actions-col" data-label="ACTIONS">
                      <button className="orders-btn-view" onClick={() => handleViewOrder(order.TransId)}>VIEW</button>
                      {/* <button className="orders-btn-track" onClick={handleClick}>TRACK ORDER</button>
                      <button className="orders-btn-invoice">INVOICE</button> */}
                    </div>
                  </div>
                ))
              ) : (
                !loading && <p className="orders-no-data-text">No orders found.</p>
              )}

              {loading && <p className="orders-loading-text">Loading...</p>}

              <div className="orders-pagination-controls">
                {pageNumber && pageNumber!==1 ?
                <button
                  className="orders-prev-btn2"
                  onClick={handlePrevious}
                  disabled={pageNumber === 1 || loading}
                >
                  Previous
                </button>
                :null}
                <span className="orders-page-info">Page {pageNumber}</span>
                {hasMore && !loading  && (
                <button
                  className="orders-next-btn2"
                  onClick={handleNext}
                  disabled={!hasMore || loading}
                >
                  Next
                </button>
                )}
              </div>

              {!hasMore && !loading && orders.length < 10 && (
                <p className="orders-no-more-text">No more orders to load.</p>
              )}
            </>
          )}
        </div>


        {/* <div className="chat-widget">
          <div className="chat-icon">💬</div>
          <div className="chat-text">Chat with us</div>
        </div> */}
      </div>
      <BottomNavigation
          cartCount={cartwishlistCount?.CartCount}
          wishlistCount={cartwishlistCount?.WishlistCount}
          onCartUpdate={() => {}}

        />


      <Footer />
    </>
  );
};

export default Orders;
